import { render, staticRenderFns } from "./bannerTop.vue?vue&type=template&id=3dd1975d&scoped=true&"
import script from "./bannerTop.vue?vue&type=script&lang=js&"
export * from "./bannerTop.vue?vue&type=script&lang=js&"
import style0 from "./bannerTop.vue?vue&type=style&index=0&id=3dd1975d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1975d",
  null
  
)

export default component.exports